import React, { useEffect, useState } from "react";
import "./UserComponent.css";
import { Container, Row, Image, Col, Modal, Button } from "react-bootstrap";
import { FaPencilAlt, FaFileAlt } from "react-icons/fa";
import { ICONS } from "../../constants/constants";
import { handleUpdateUser } from "../../store/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleDeleteSupplier } from "../../store/actions/suppliersActions";
import { handleDeleteConsultant, handleGetNearConsultantList } from "../../store/actions/consultantsActions";
import { handleAssignConsultant, handleChangeConsultant, handleDeleteFarmer } from "../../store/actions/farmersActions";
import EditFarmerModal from "../Modals/EditFarmerModal";
import ConsultantSelectionModal from "../Modals/ConsultantSelectionModal";
import NewConsultantSelectionModal from "../Modals/NewConsultantSelectionModal";

const UserComponent = ({ user, userDetails, documents, onEdit }) => {
  // const { updateUser } = useSelector((state) => state.user);
  const { user: userData } = useSelector((state) => state.user);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showConsultantModal, setShowConsultantModal] = useState(false);
  const [showNewConsultantModal, setShowNewConsultantModal] = useState(false);
   // State to control consultant modal visibility
  // const [consultants, setConsultants] = useState([]); // State to store available consultants
  const [consultants, setConsultants] = useState([]);
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [showEditModal, setShowEditModal] = useState(false); // State to control edit modal visibility



  const [selectedDocument, setSelectedDocument] = useState(null); // State to store selected document

  
  // const [isEditing, setIsEditing] = useState(false);
  // State to toggle edit mode
  const getDocumentIcon = (fileName) => {
    if (!fileName || typeof fileName !== "string") {
      // console.warn("Invalid fileName:", fileName); // Log a warning for debugging
      return ICONS.documentIcon; // Return a default icon or handle the case as needed
    }

    const fileExtension = fileName.trim().split(".").pop().toLowerCase();

    switch (fileExtension) {
      case "pdf":
        return ICONS.pdfIcon; // Ensure this path is correct
      case "docx":
      case "doc":
        return ICONS.wordIcon;
      case "jpg":
      case "jpeg":
      case "png":
      case "svg":
        return ICONS.imageIcon;
      default:
        return ICONS.documentIcon;
    }
  };

  // useEffect(() => {
  //   if (
  //     updateUser.data.assignedConsultant === null ||
  //     updateUser.data.assignedConsultant.message ===
  //       "No available consultants found"
  //   ) {
  //     setShowConsultantModal(true); // Show the modal if conditions are met
  //     // Fetch or set available consultants here if needed
  //     // setConsultants(fetchedConsultants);
  //   }
  // }, [updateUser.data.assignedConsultant, updateUser.data.message]); // Dependency array to trigger effect

  // Handle document click to show modal

  const handleDocumentClick = (doc) => {
    setSelectedDocument(doc);
    setShowModal(true); // Show the modal
  };

  // Close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedDocument(null); // Clear selected document
  };
 

  const approveUser = async (id, updateUser) => {
    const formData = { account_status: "Approved" };
    const user = await handleUpdateUser(id, formData, dispatch);
    if (
      updateUser.userdatarole === "farmer" && // ✅ Check if the user is a farmer
    (
      user?.data?.assignedConsultant === null ||
      user?.data?.assignedConsultant?.message === "No available consultants found" ||
      user?.data?.assignedConsultant?.message === "No available consultants with open slots"
    )
      
    ) {
      setShowConsultantModal(true); // Show the modal if conditions are met
      const nearByConsultantList = await handleGetNearConsultantList(
        'consultant',
        updateUser.latitude,
        updateUser.longitude,
        1,
        10
      )(dispatch);
     // Update consultants state
     setConsultants(nearByConsultantList?.data?.users || []);  
    
    }
    
    // if (updateUser.userdatarole === "farmer") {

      
    //     navigate("/farmers");
      

      
    // } else
     if (updateUser.userdatarole === "supplier") {
      navigate("/suppliers");
    } else if (updateUser.userdatarole === "consultant") {
      navigate("/consultants");
    }
  };

  // Combined delete action for all types of users
  const deleteUser = (id, role) => {
    if (role === "supplier") {
      dispatch(handleDeleteSupplier(id)); // Dispatch delete action for supplier
    } else if (role === "consultant") {
      dispatch(handleDeleteConsultant(id)); // Dispatch delete action for consultant
    } else if (role === "farmer") {
      dispatch(handleDeleteFarmer(id)); // Dispatch delete action for farmer
    }
  };

  const handleShowConsultantList = async (detail) => {
    setShowNewConsultantModal(true); // Show the modal if conditions are met
    const nearByConsultantList = await handleGetNearConsultantList(
      'consultant',
      detail.latitude,
      detail.longitude,
      1,
      10
    )(dispatch);
   // Update consultants state
   setConsultants(nearByConsultantList?.data?.users || []);  
  }

  // Convert to d/m/y format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Handle edit icon click to show edit modal
  const handleEditClick = () => {
    setShowEditModal(true); // Show the edit modal
  };


  
  const handleAssign = async (formData) => {
    // Call the API helper to assign the consultant
    const result = await handleAssignConsultant(formData, dispatch);
    navigate("/farmers");
    // Close the modal after assignment
    //setShowConsultantModal(false);
  };


  const changeConsultant = async (formData) => {
    // Call the API helper to assign the consultant
    const result = await handleChangeConsultant(formData, dispatch);
    if(result)
      {
      setShowNewConsultantModal(false);
      navigate("/farmers");
    }
    //navigate("/farmers");
    // Close the modal after assignment
    //setShowConsultantModal(false);
  };

  console.log('userDetails', userDetails);
  return (
    <>
      <div className="user-container">
        <div className="profile-card p-3">
          {/* Edit icon (visible when parent passes onEdit) */}
          {onEdit && (
            <FaPencilAlt
              className="edit-icon"
              onClick={() => {
                if (typeof onEdit === "function") onEdit();
                else handleEditClick();
              }}
              style={{ cursor: "pointer", color: "white" }}
              title="Edit profile"
            />
          )}

          <Row className="align-items-center">
            {/* Left side - Profile Image */}
            <Col xs={1} className="text-center farmer-image">
              {user?.profileImage ? (
                <Image
                  src={user.profileImage}
                  roundedCircle
                  width={70}
                  height={70}
                  alt="User profile"
                />
              ) : (
                <div className="user-icon">{user?.name?.charAt(0)}</div>
              )}
            </Col>

            {/* Center - Name and Email */}
            <Col xs={8} className="text-start ps-2">
              <h2 className="username m-0">{user.name}</h2>
              {/* Role */}
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <span className="role-badge" style={{ fontSize: "0.85rem", padding: "0.2rem 0.5rem", background: "#ffffff30", color: "white", borderRadius: "4px", textTransform: "capitalize" }}>
                  {user.userdatarole || user.role || "User"}
                </span>
                <h6 className="user-email m-0" style={{ marginLeft: "0.5rem" }}>{user.email}</h6>
              </div>
            </Col>
          </Row>
          <p className="joined-date">Joined on {formatDate(user.joinedDate)}</p>
        </div>

        {/* User Details */}
        <Row className="user py-3">
          {userDetails
            .filter((detail) => {
              // hide CNIC and phone/mobile labels for manager viewers
              if (userData?.role === "manager") {
                const lbl = (detail.label || "").toLowerCase();
                if (lbl.includes("cnic") || lbl.includes("mobile") || lbl.includes("phone")) {
                  return false;
                }
              }
              return true;
            })
            .map((detail, index) => (
            <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-2">
              <h6>{detail.label}</h6>
              <p>{detail.value}</p>

              {detail.label === "Consultant" && userData?.role !== "manager" && (
                <Button
                  className="button"
                  onClick={() => handleShowConsultantList(user)}
                >
                  Change Consultant
                </Button>
              )}

            </Col>
          ))}
          
          {/* <Col lg={12} className="flexisblle">
            {farmer?.farmerConsultants[0]?.consultantUser ? (
              <Button className="button" 
              //onClick={handleShiriahModalShow}
              >
                Change Consultant
              </Button>
            ) : (
              <span className="text-center">
                Assign Consultant
              </span>
              // <Button className="button">Show Shiriah Budget</Button>
            )}
          </Col> */}
        </Row>

        {/* Conditionally Render Documents Row */}

        {documents && Object.keys(documents).length > 0 && userData?.role !== "manager" && (
          <Row className="document-row">
            <Col xs={12} className="py-2">
              <h5>Farm Documents</h5>
            </Col>
            {Object.keys(documents).map((docKey, index) => (
              <Col key={index} xs={12} md={3} className="mb-3">
                <div
                  className="d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDocumentClick(documents[docKey][0])}
                >
                  {/* Dynamically Render Document Icon */}
                  <img
                    src={getDocumentIcon(documents[docKey][0]?.link)}
                    alt="document icon"
                    size={40}
                    className="document-icon me-3"
                    // On click, show modal
                  />

                  {/* Document Details */}
                  <div className="document">
                    <h6>{docKey.replace(/([A-Z])/g, " $1").trim()}</h6>{" "}
                    {/* Capitalize document type name */}
                    {documents[docKey].map((doc, docIndex) => (
                      <div key={docIndex}>
                        <p>
                          {/* <a href={doc.link} target="_blank" rel="noopener noreferrer">{doc.title}</a>  */}
                          {doc.title}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        )}
        <ConsultantSelectionModal
          show={showConsultantModal}
          handleClose={() => setShowConsultantModal(false)}
          // consultants={consultants} // Pass available consultants to the modal
          farmerId={user.id}
          consultants={consultants}
          handleAssign={handleAssign}
        />

<NewConsultantSelectionModal
          show={showNewConsultantModal}
          handleClose={() => setShowNewConsultantModal(false)}
          // consultants={consultants} // Pass available consultants to the modal
          farmerId={user.id}
          consultants={consultants}
          changeConsultant={changeConsultant}
        />

        
        {/* Modal to Show Selected Document */}
        <Modal show={showModal} fullscreen onHide={handleCloseModal}>
          {/* <Modal.Header closeButton>
            <Modal.Title>{selectedDocument?.title}</Modal.Title>
          </Modal.Header> */}
          <Modal.Body
            style={{
              padding: 0,
              margin: 0,
              height: "100vh",
              overflow: "hidden",
            }}
          >
            <p>
              {selectedDocument
                ? selectedDocument.title
                : "Loading document..."}
            </p>
            <iframe
              src={selectedDocument?.link}
              className="document-preview"
              title="Document Preview"
              style={{ width: "100%", height: "100vh", border: "none" }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Edit Modal */}
        <EditFarmerModal
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          user={user}
          userType={user?.userdatarole}
        />
      </div>

      {user.account_status !== "Approved" && userData?.role !== "manager" && (
        <Col xs={11} className="text-end mb-3">
          <Button
            className="button reject-button"
            onClick={() => deleteUser(user.id, user.userdatarole)}
          >
            Reject
          </Button>
          <Button
            className="button delete-button ms-2"
            onClick={() => approveUser(user.id, user)}
            disabled={user.otp_status === "NotVerified"}
          >
            Approve
          </Button>
        </Col>
      )}
    </>
  );
};

export default UserComponent;
